export const DESKTOP_MARKER_DISTANCE = 1.0;
export const DESKTOP_MARKER_SCALE = 0.08;
export const MARKER_MODEL_WIDTH = 0.5;
export const MAX_WIDTH_FOR_MARKERS_ABOVE_ROOMS = 0.25;
export const MAX_SCALE_FOR_MARKERS_ABOVE_ROOMS = MAX_WIDTH_FOR_MARKERS_ABOVE_ROOMS / MARKER_MODEL_WIDTH;
